import { HiOutlineArrowRight } from "react-icons/hi";
import { LinkButtonWithIcon, StyledButton } from "../FacilityOnboarding.styles";
import { OnboardingStep } from "./OnboardingStep";
import { Stack } from "@mui/material";

interface WorkerInvitationOnboardingStepProps {
  visibleStepCount: number;
  isCompleted: boolean;
  onSkip: () => void;
  onInvite: () => void;
  isLoading: boolean;
}

export function WorkerInvitationOnboardingStep(props: WorkerInvitationOnboardingStepProps) {
  const { visibleStepCount, isCompleted, onSkip, onInvite, isLoading } = props;

  return isCompleted ? (
    <OnboardingStep
      key="worker-invitation"
      title={<>You can invite staff to join Clipboard anytime!</>}
      description={
        <LinkButtonWithIcon underline={false} color="primary" onClick={onInvite}>
          Invite staff
          <HiOutlineArrowRight />
        </LinkButtonWithIcon>
      }
      completed
    />
  ) : (
    <OnboardingStep
      key="worker-invitation"
      title={<>Invite Professionals You Know to Join Clipboard with You!</>}
      description={
        <>
          Do you have staff members in mind that you have enjoyed working with in the past? Give us
          their name and phone number and we&apos;ll send them a link to join Clipboard and let them
          know that you&apos;ll be posting shifts soon.
        </>
      }
      step={visibleStepCount}
      completed={false}
      footer={
        <Stack direction="row" spacing={2}>
          <StyledButton variant="primary" size="lg" onClick={onInvite}>
            Invite Staff
          </StyledButton>
          <StyledButton
            variant="secondary"
            size="lg"
            onClick={onSkip}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Skip
          </StyledButton>
        </Stack>
      }
    />
  );
}
